var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-equalizer",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{11.11111111111111 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 73.3261,
    fill: "#1d3f72",
    x: 6.111111111111111,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "-0.875s",
    dur: 1
  })), /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{22.22222222222222 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 42.1259,
    fill: "#5699d2",
    x: 17.22222222222222,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "-0.5s",
    dur: 1
  })), /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{33.333333333333336 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 16.2353,
    fill: "#d8ebf9",
    x: 28.333333333333336,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "-0.375s",
    dur: 1
  })), /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{44.44444444444444 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 10.5728,
    fill: "#71c2cc",
    x: 39.44444444444444,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "-0.25s",
    dur: 1
  })), /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{55.55555555555556 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 58.6881,
    fill: "#4996a2",
    x: 50.55555555555556,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "-0.75s",
    dur: 1
  })), /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{66.66666666666667 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 50.0754,
    fill: "#785471",
    x: 61.66666666666667,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "-0.625s",
    dur: 1
  })), /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{77.77777777777777 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 36.5073,
    fill: "#e8cdc5",
    x: 72.77777777777777,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "-0.125s",
    dur: 1
  })), /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{88.88888888888889 - config.width/2}}",
    y: 15,
    "ng-attr-width": "{{config.width}}",
    height: 72.0007,
    fill: "#eee7d8",
    x: 83.88888888888889,
    width: 10
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    calcMode: "spline",
    values: "50;75;10;50",
    times: "0;0.33;0.66;1",
    "ng-attr-dur": "{{config.speed}}",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    repeatCount: "indefinite",
    begin: "0s",
    dur: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loading_spinner.7b0ca7266875bccd6f8521ebfe7f4d13.svg";
export { ForwardRef as ReactComponent };